import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CardStyle, DocActionButton, PositionIcon, Size } from '../../../base/src/abcCard/abcCard';

enum TemplateEnum {
  Large,
  Medium,
  Small,
}

@Component({
    selector: '',
    template: `
    <mat-card
      [dir]="rtlEnabled"
      [class]="class"
      #matCard
      [id]="id"
      (click)="this.onCardClick.emit()"
      (dblclick)="this.onCardDblClick.emit()"
      [class.subDivContentCardList]="colorBar"
      [attr.style]="'border-left-color:' + colorBar + '!important; height:' + height + 'px !important'"
      >
      <mat-card-header class="matCardHeader" fxLayout="row" fxFlex>
        <div fxLayout="column" fxLayoutAlign="start" fxFlex fxLayoutGap="0px" class="header">
          @if (displayText) {
            <mat-card-title
              class="ellipsisOneLine"
              [id]="cardId"
              (mouseenter)="isEllipsisActive(id)"
              [matTooltipDisabled]="disabledTooltip"
              [matTooltip]="displayText"
              [ngClass]="!secondaryDisplayText ? 'centredTitle' : ''"
              >
              @if (leftIconPosition === positionIcon.Top) {
                <mat-icon
                  fxFlex="32px"
                  class="abcCardMatIcon"
                  svgIcon="{{ leftIconPath }}"
                ></mat-icon>
              }
              <span [innerHTML]="displayText | highlightSearch: searchInput"></span>
            </mat-card-title>
          }
          <mat-card-subtitle
            class="ellipsisOneLine"
            [id]="secondaryDisplayText"
            (mouseenter)="isEllipsisActive(secondaryDisplayText)"
            [matTooltipDisabled]="disabledTooltip"
            [matTooltip]="secondaryDisplayText"
            >
            <span> {{ secondaryDisplayText }} </span>
          </mat-card-subtitle>
          @if (headerDescription) {
            <div fxLayout="row" class="description ellipsisOneLine">
              <span>{{ description }}</span>
            </div>
          }
        </div>
        @if (leftIconPosition === positionIcon.Middle) {
          <div
            [ngClass]="{ sizeIconLarge: leftIconSize === size.Large, sizeIconSmall: leftIconSize === size.Small }"
            [ngStyle]="{ overflow: leftIsImg ? 'hidden' : 'visible' }"
            mat-card-avatar
            class="cardAvatar"
            >
            @if (leftIsImg) {
              <div>
                @if (leftIconPath) {
                  <img [src]="leftIconPath" class="rightImg" />
                }
                @if (!leftIconPath) {
                  <mat-icon svgIcon="profile-user" class="defaultIcon"></mat-icon>
                }
              </div>
            }
            @if (!leftIsImg) {
              <mat-icon fxFlex class="divIconCard" svgIcon="{{ leftIconPath }}"> </mat-icon>
            }
          </div>
        }
    
        @if (!rightIsImg && rightIconPath) {
          <button mat-flat-button class="matButtonContact">
            <mat-icon style="background-size: 10px 10px;" class="arrowIcon" svgIcon="{{ rightIconPath }}"></mat-icon>
          </button>
        }
        @if (rightIsImg) {
          <div class="rightIsImg">
            @if (rightIconPath) {
              <img [src]="rightIconPath" class="rightImg" />
            }
            @if (!rightIconPath && !shortHand) {
              <mat-icon svgIcon="profile-user" class="defaultIcon"></mat-icon>
            }
            @if (!rightIconPath && shortHand) {
              <div class="cardFirstLetters">
                {{ shortHand }}
              </div>
            }
          </div>
        }
      </mat-card-header>
      @if (description && !headerDescription) {
        <mat-card-content> {{ description }} </mat-card-content>
      }
      @if (primaryActionName || secondaryActionName || buttons) {
        <mat-card-actions>
          @if (buttons) {
            <div class="cardButtonsStyle">
              @for (btn of buttons; track btn) {
                <button
                  mat-mdc-icon-button
                  [disabled]="!btn.visible"
                  (click)="btn.click(); $event.stopPropagation()"
                  >
                  @if (btn.visible) {
                    <mat-icon [svgIcon]="btn.icon" [id]="btn.id"></mat-icon>
                  }
                </button>
              }
            </div>
          }
          @if (primaryActionName) {
            <button mat-mdc-icon-button>
              <mat-icon
                class="customIconSize"
                [svgIcon]="primaryActionName"
                (click)="primaryActionClick(); $event.stopPropagation()"
                >
              </mat-icon>
            </button>
          }
          @if (secondaryActionName) {
            <button mat-mdc-icon-button>
              <mat-icon class="customIconSize" [svgIcon]="secondaryActionName" (click)="secondaryActionClick()"> </mat-icon>
            </button>
          }
          <!-- <button mat-mdc-icon-button>
          <mat-icon class="customIconSize" [svgIcon]="'moreOptions'"> </mat-icon>
        </button> -->
      </mat-card-actions>
    }
    </mat-card>
    `,
    styleUrls: ['./matCard.component.scss'],
    standalone: false
})
export class MatCardComponent implements AfterViewInit {
  @Input() id: any;
  @Input() displayText: string;
  @Input() icon: string;
  @Input() buttons: DocActionButton[];
  @Input() secondaryDisplayText: string;
  @Input() template: number;
  @Input() searchInput: string;
  @Input() height: string | number;
  @Input() width: string;
  @Input() image: string;
  @Input() colorBar: string;
  @Input() leftIconPath: string;
  @Input() rightIconSize: number;
  @Input() leftIconSize: number;
  @Input() leftIconPosition: number;
  @Input() rightIconPath: string;
  @Input() rightIsImg: boolean;
  @Input() leftIsImg: boolean;
  @Input() disabledTooltip: boolean = false;
  @Input() description: string;
  @Input() shortHand: string;
  @Input() primaryActionName;
  @Input() secondaryActionName;
  @Input() rtlEnabled: string;
  @Input() headerDescription: boolean;
  @Input() class: string;
  @ViewChild('matCard', { static: true, read: ElementRef }) matCard;
  @Output() onCardClick = new EventEmitter();
  @Output() onCardDblClick = new EventEmitter();
  @Output() onPrimaryActionClick = new EventEmitter();
  @Output() onSecondaryActionClick = new EventEmitter();
  public templateLarge: TemplateEnum = TemplateEnum.Large;
  public templateSmall: TemplateEnum = TemplateEnum.Small;
  public size = Size;
  public positionIcon = PositionIcon;
  public cardId: string;
  public errorImg: boolean = true;
  constructor(private renderer2: Renderer2, private sanitizer: DomSanitizer) {
    this.headerDescription = true;
  }

  ngOnInit() {
    this.leftIconPosition = Number(this.leftIconPosition);
    this.leftIconSize = Number(this.leftIconSize);
    if (this.displayText) this.cardId = this.displayText.toString().replace(/\s/g, '');
  }

  ngAfterViewInit() {
    if (this.class) {
      const element = this.matCard.nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }

  public isEllipsisActive(id): void {
    const e = document.getElementById(id);
    this.disabledTooltip = e.clientWidth >= e.scrollWidth;
  }

  public setCardStyle(style: CardStyle): void {
    this.height = style.height;
    const element = this.matCard.nativeElement;
    if (style) {
      for (const key in style) {
        element.style[key] = style[key];
      }
    }
  }

  public primaryActionClick(): void {
    this.onPrimaryActionClick.emit();
  }

  public secondaryActionClick(): void {
    this.onSecondaryActionClick.emit();
  }
}
